import { AuthMode } from './components/AuthEmailHeading';
import { TEAM_ACCEPT_RETURN_TO } from './teamAcceptReturnTo';
import { COVER_CARRY_RETURN_TO } from '../../coverEditor/publicMode/publicCoverPath';

interface AuthModeParams {
  /** `?mode=`: `signin` or `signup`. An explicit value always wins. */
  mode: string;
  /** `?returnTo=`: the private page that a signed-out visit asked for. */
  returnTo: string;
  /** `?sourceType=`: the website sends `login` from its "Sign in" link, `signup` from "Start free". */
  sourceType: string;
}

/**
 * The `returnTo` pages that a new person reaches before an account exists. They keep the signup
 * copy. The team invite has its own copy (`AuthEmailHeading`).
 */
const SIGNUP_RETURN_PATHS = new Set<string>([COVER_CARRY_RETURN_TO, TEAM_ACCEPT_RETURN_TO]);

function returnPathOf(returnTo: string): string {
  return (returnTo.split('?')[0] ?? '').replace(/^\/+/, '').replace(/\/+$/, '');
}

/**
 * The first copy of `/app/auth` (QA 2026-10-24 B01). A returning person sees the sign-in copy:
 * `?mode=signin`, the website "Sign in" link (`sourceType=login`), or a signed-out visit to a
 * private page (`returnTo`, for example a link of an email). Everything else is the signup copy.
 * Pure.
 */
export function authInitialMode({ mode, returnTo, sourceType }: AuthModeParams): AuthMode {
  if (mode === 'signin') {
    return 'signin';
  }
  if (mode === 'signup') {
    return 'signup';
  }
  if (sourceType === 'login') {
    return 'signin';
  }
  if (sourceType === 'signup') {
    return 'signup';
  }
  const returnPath = returnPathOf(returnTo);
  if (returnPath !== '' && !SIGNUP_RETURN_PATHS.has(returnPath)) {
    return 'signin';
  }
  return 'signup';
}
